import React, { useState, useEffect } from 'react';
import './InteractiveImageComponent.css';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';

import procedures from './procedures7.jpg';
import surgeries from './surgery7.jpg';

function InteractiveImageComponent() {
  const [currentImage, setCurrentImage] = useState(procedures);
  const [hoveredSection, setHoveredSection] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];

  const sections = [
    { name: 'PROCEDURES', image: procedures },
    { name: 'SURGERIES', image: surgeries },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleMouseEnter = (section) => {
    setCurrentImage(section.image);
    setHoveredSection(section.name);
  };

  const handleSectionClick = (section) => {
    window.scrollTo(0, 0);
    if (section.name === 'PROCEDURES') {
      navigate('/procedures');
    } else if (section.name === 'SURGERIES') {
      navigate('/surgeries');
    }
  };

  if (isSmallScreen) {
    return null;
  }

  return (
    <div
      className="interactive-image-container"
      style={{ backgroundImage: `url(${currentImage})` }}
    >
      <div className="interactive-sections">
        {sections.map((section) => (
          <div
            key={section.name}
            onMouseEnter={() => handleMouseEnter(section)}
            onMouseLeave={() => setHoveredSection(null)}
            onClick={() => handleSectionClick(section)}
            style={{ opacity: hoveredSection === section.name ? 1 : 0 }}
          >
            {section.name === 'PROCEDURES' ? t.procedures : t.surgeries}
          </div>
        ))}
      </div>
    </div>
  );
}

export default InteractiveImageComponent;
